<template>
    <vue-scroll v-if="form.dept_list_items.length">
        <div class="dept-list-container">
            <div class="info-text">
                <p>
                    The Department List appears on the front page of your
                    newsletter. There is limited space, and depending on the
                    design of your masthead, Corwin recommends a maximum of
                    10-15 lines in this list. Adding more lines will decrease
                    the size of the text, and will make the list hard to read.
                </p>
                <b
                    >To reorder the list, click on the line number and drag it
                    into place.</b
                >
            </div>

            <div class="dept-list-card">
                <h3 class="card-title">Department List</h3>
                <el-form>
                    <el-form-item label="Headline">
                        <el-input
                            maxlength="35"
                            v-model="form.dept_list_headline"
                            style="width: 70%"
                        />
                    </el-form-item>
                    <div class="w-full">
                        <div class="column-headers">
                            <strong>Column One Info</strong>
                            <strong>Corresponding Info</strong>
                        </div>
                        <draggable
                            v-model="form.dept_list_items"
                            @end="onEnd"
                            class="list-group"
                            ghost-class="ghost"
                        >
                            <tr
                                v-for="(event, i) in form.dept_list_items"
                                :key="i"
                                class="list-group-item"
                            >
                                <td>{{ i + 1 }}.</td>
                                <td>
                                    <el-input
                                        maxlength="35"
                                        v-model="event.value_1"
                                    />
                                </td>
                                <td>
                                    <el-input
                                        maxlength="35"
                                        v-model="event.value_2"
                                    />
                                </td>
                                <td>
                                    <el-button
                                        size="small"
                                        type="danger"
                                        icon="mdi mdi-delete"
                                        @click="removeItem(event)"
                                    ></el-button>
                                </td>
                            </tr>
                        </draggable>
                        <div class="add-button">
                            <el-button
                                size="small"
                                type="primary"
                                round
                                icon="mdi mdi-plus"
                                @click="addItem()"
                                >Add Line
                            </el-button>
                        </div>
                    </div>
                </el-form>
            </div>
        </div>
    </vue-scroll>
</template>

<script>
import draggable from "vuedraggable";
export default {
    props: {
        newsletter: {
            required: true,
            type: Object
        },
        form: {
            type: Object,
            required: true
        }
    },
    components: {
        draggable
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {
        addItem() {
            this.form.dept_list_items.push({
                newsletter_id: this.newsletter.id,
                id: null,
                value_1: null,
                value_2: null
            });
            this.updateScroller();
        },
        removeItem(item) {
            this.$confirm(
                "Are you sure you want to remove item?",
                "Confirmation",
                {
                    type: "warning",
                    confirmButtonClass: "el-button--danger",
                    confirmButtonText: "Remove"
                }
            )
                .then(() => {
                    Utils.arrayDelete(this.form.dept_list_items, item);
                    this.updateScroller();
                })
                .catch(() => {
                    //user cancelled
                });
        },
        onEnd(evt) {
            this.updateScroller();
        }
    }
};
</script>

<style scoped>
.dept-list-container {
    max-width: 1100px;
    margin: 0; /* Changed from margin: 0 auto; to remove centering */
    padding-bottom: 20px; /* Added padding for spacing from bottom edge */
}

.info-text {
    margin-bottom: 20px;
}

.dept-list-card {
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 20px;
    border: 1px solid #eaeaea;
    margin-top: 15px;
}

.card-title {
    margin-bottom: 20px;
    padding-left: 5px;
    color: #333;
    font-size: 18px;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 10px;
}

.column-headers {
    display: flex;
    margin-bottom: 10px;
}

.column-headers strong:first-child {
    margin-left: 3%;
    width: 350px;
}

.column-headers strong:last-child {
    margin-left: 20px;
    width: 350px;
}

.list-group {
    display: flex;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
    min-height: 20px;
}

.list-group-item {
    position: relative;
    display: block;
    cursor: move;
}

.list-group-item td {
    padding: 5px;
}

.list-group-item td:nth-child(2),
.list-group-item td:nth-child(3) {
    width: 350px;
}

.add-button {
    margin-left: 5%;
    margin-top: 10px;
}

/* Ghost class for draggable */
.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}
</style>
